import tiles from './data-tiles'

export default [
		{name:1, distance:15, startTiles: tiles.startTiles, endTiles:tiles.endTiles, drawTiles:tiles.standardTiles, introText: 'Tubers' },
		{name:2, distance:16, startTiles: tiles.startTiles, endTiles:tiles.endTiles, drawTiles:tiles.standardTiles, introText: 'Level 2' },
		{name:3, distance:17, startTiles: tiles.startTiles, endTiles:tiles.endTiles, drawTiles:tiles.standardTiles, introText: 'Level 3' },
		{name:4, distance:18, startTiles: tiles.startTiles, endTiles:tiles.endTiles, drawTiles:tiles.standardTiles, introText: 'Level 4' },
		{name:5, distance:19, startTiles: tiles.startTiles, endTiles:tiles.endTiles, drawTiles:tiles.standardTiles, introText: 'Level 5' }
	]


